module.exports = __webpack_public_path__ + "img/colaboration-of-uned.d7219c51.png";